export default __webpack_public_path__ + "media/src/assets/images/chequeMenu-b41628d4a1dd95bdcf45403b9a5836dd.png";